/**
 * Generated by orval v8.11.0 🍺
 * Do not edit manually.
 * Core API
 * Core API Documentation
 * OpenAPI spec version: 1.0
 */

export enum CreateClosureDtoType {
  BANK_HOLIDAY = "BANK_HOLIDAY",
  INSET_TRAINING = "INSET_TRAINING",
  SEASONAL = "SEASONAL",
  AD_HOC = "AD_HOC",
}
